import React from 'react';
import { DatePicker } from 'antd';
import { Dayjs } from 'dayjs';
import { TextComponent } from 'baseComponents/TextComponent';
import { CalendarIcon } from 'assets/icons/calendarIcon';
import 'baseComponents/DatePickerComponent/datePickerComponent.scss';

interface Props {
  onChange: (value: Dayjs | null, dateString: string) => void;
  value: Dayjs | null;
  disabledDate?: (current: Dayjs | undefined) => boolean;
}

export const DatePickerComponent: React.FC<Props> = (props) => {
  return (
    <div>
      <TextComponent text='Date' size='middle' weight='extra-light' />
      <DatePicker
        onChange={props.onChange}
        value={props.value}
        bordered
        className='date-picker-input'
        popupClassName='calendar-card'
        allowClear={false}
        superNextIcon={<></>}
        superPrevIcon={<></>}
        showToday={false}
        disabledDate={props.disabledDate}
        suffixIcon={<CalendarIcon />}
      />
    </div>
  );
};
